// extracted by mini-css-extract-plugin
export var backToShop = "product-page-module--backToShop--en9Yq";
export var container = "product-page-module--container--qTf+g";
export var fewVariants = "product-page-module--fewVariants--Sw7Hj";
export var giftWrap = "product-page-module--giftWrap--wVgBj";
export var header = "product-page-module--header--JMWdQ";
export var info = "product-page-module--info--apseU";
export var manyVariants = "product-page-module--manyVariants--MfJYO";
export var metaSection = "product-page-module--metaSection--oaKqQ";
export var mobileBackToShop = "product-page-module--mobileBackToShop--BB+TQ";
export var modal = "product-page-module--modal--DDzbm";
export var modalOpener = "product-page-module--modalOpener--8Mytx";
export var noImagePreview = "product-page-module--noImagePreview--cmRqH";
export var optionsWrapper = "product-page-module--optionsWrapper--95Dfh";
export var priceValue = "product-page-module--priceValue--XWzj2";
export var productDescription = "product-page-module--productDescription--o+Q8M";
export var productImageWrapper = "product-page-module--productImageWrapper--0KAgU";
export var productTitleAndSubtitle = "product-page-module--productTitleAndSubtitle--jnmkv";
export var purchaseInfo = "product-page-module--purchaseInfo--qIDB+";
export var subheader = "product-page-module--subheader--wOhNf";
export var visuallyHidden = "product-page-module--visuallyHidden--TSIT6";